import { useEffect } from "react";

import { getSupabaseClient } from "../providers/supabase/supabase";
import { enterApp } from "./enterApp";

/**
 * Leaves the login page as soon as the browser holds a session: one found on
 * mount (INITIAL_SESSION fires right after subscribing) or one refreshed or
 * signed in later, e.g. in another tab.
 */
export const useEnterAppWithSession = (redirectTo?: string) => {
  useEffect(() => {
    let entered = false;
    const { data } = getSupabaseClient().auth.onAuthStateChange(
      (event, session) => {
        if (entered || session == null) return;
        if (
          event === "INITIAL_SESSION" ||
          event === "SIGNED_IN" ||
          event === "TOKEN_REFRESHED"
        ) {
          entered = true;
          enterApp(redirectTo);
        }
      },
    );
    return () => data.subscription.unsubscribe();
  }, [redirectTo]);
};
